import React from 'react'
import { Box, useTheme, Stack } from '@mui/material'

const UserHistorySkeleton: React.FC = () => {
  const theme = useTheme()
  
  const skeletonItems = Array(7).fill(0)
  
  return (
    <Box sx={{ width: '100%' }}>
      {skeletonItems.map((_, index) => (
        <Box 
          key={index}
          sx={{
            pb: 4
          }}
        >
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 1,
          }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <Box 
                sx={{ 
                  width: 10, 
                  height: 10, 
                  borderRadius: '50%',
                  backgroundColor: '#EFEFEF',
                  animation: 'pulse 1.5s infinite ease-in-out'
                }} 
              />
              <Box 
                sx={{ 
                  width: 100, 
                  height: 10, 
                  borderRadius: 1,
                  backgroundColor: '#EFEFEF',
                  animation: 'pulse 1.5s infinite ease-in-out'
                }} 
              />
            </Box>
            
            <Box sx={{
              flex: 1,
              mx: 2,
              height: '1px',
              backgroundColor: theme.palette.grey[100]
            }} />
            
            <Box 
              sx={{ 
                width: 80, 
                height: 10, 
                borderRadius: 1,
                backgroundColor: '#EFEFEF',
                animation: 'pulse 1.5s infinite ease-in-out'
              }} 
            />
          </Box>
          
          <Box sx={{ pl: 2, pt: 1 }}>
            <Box
              sx={{
                pb: 2,
                pl: 2,
                position: 'relative',
              }}
            >
              <Stack direction="row" sx={{ position: 'absolute', left: 0, top: 0, height: '100%' }}>
                <Box sx={{ width: '12px', position: 'relative' }}>
                  <Box sx={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '10px',
                    width: 0,
                    borderLeft: `solid 1px ${'#EFEFEF'}`,
                  }} />
                  
                  <Box sx={{
                    position: 'absolute',
                    left: 0,
                    top: '10px',
                    width: '12px',
                    height: 0,
                    borderTop: `solid 1px ${'#EFEFEF'}`,
                    borderTopLeftRadius: 6,
                  }} />
                  
                  <Box sx={{
                    position: 'absolute',
                    left: 0,
                    top: '10px',
                    bottom: 0,
                    width: 0,
                    borderLeft: `solid 1px ${'#EFEFEF'}`,
                  }} />
                </Box>
              </Stack>
              
              <Box 
                sx={{ 
                  width: 120, 
                  height: 10, 
                  borderRadius: 1,
                  backgroundColor: '#EFEFEF',
                  mb: 1,
                  animation: 'pulse 1.5s infinite ease-in-out'
                }} 
              />
              
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}>
                <Box 
                  sx={{ 
                    width: 80, 
                    height: 10, 
                    borderRadius: 1,
                    backgroundColor: '#EFEFEF',
                    animation: 'pulse 1.5s infinite ease-in-out'
                  }} 
                />
                <Box 
                  sx={{ 
                    width: 10, 
                    height: 10, 
                    borderRadius: '50%',
                    backgroundColor: '#EFEFEF',
                    animation: 'pulse 1.5s infinite ease-in-out'
                  }} 
                />
                <Box 
                  sx={{ 
                    width: 80, 
                    height: 10, 
                    borderRadius: 1,
                    backgroundColor: '#EFEFEF',
                    animation: 'pulse 1.5s infinite ease-in-out'
                  }} 
                />
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
      
      <Box
        sx={{
          '@keyframes pulse': {
            '0%': {
              opacity: 0.6,
            },
            '50%': {
              opacity: 1,
            },
            '100%': {
              opacity: 0.6,
            },
          },
        }}
      />
    </Box>
  )
}

export default UserHistorySkeleton